import AntdRadio from 'antd/es/radio';

import Radio from './Radio';
const AntdRadioType: typeof AntdRadio = Object.assign({}, AntdRadio, Radio);

export default AntdRadioType;

export type { RadioChangeEvent } from 'antd/es/radio';
